module.exports = __webpack_public_path__ + "media/images/mailer/logo-fef301d483df6fd030369d1e12d357df.png";